import React from 'react';

export default function PendingApproval() {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Account Pending Approval</h1>
        <p style={styles.text}>
          Your account is pending admin approval. You'll receive an email when you're approved and can start working.
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh', display: 'flex', alignItems: 'center',
    justifyContent: 'center', background: '#f0f2f5',
  },
  card: {
    background: '#fff', padding: '2rem', borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)', maxWidth: '400px', width: '100%',
    textAlign: 'center',
  },
  title: { margin: '0 0 1rem', fontSize: '1.5rem', color: '#2c3e50' },
  text: { color: '#555', lineHeight: 1.6 },
};
